/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturInstallIcon24Solid = forwardRef('KonturInstallIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm1.69-9.547a1.75 1.75 0 1 0-1.237 1.238l3.428 3.428a.875.875 0 1 0 1.238-1.238l-3.428-3.428Zm-1.908-5.949a.75.75 0 0 1-.059-1.499 7.052 7.052 0 0 1 5.633 2.488 7.052 7.052 0 0 1 1.488 5.974.75.75 0 1 1-1.466-.314 5.566 5.566 0 0 0-1.17-4.695 5.566 5.566 0 0 0-4.426-1.954Z" })));
});
